import { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Mail, ArrowRight, RefreshCw } from "lucide-react";
import { toast } from "sonner";
import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const VerifyEmailPage = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const email = location.state?.email || "tu correo"; // Recibe el email del registro
  
  const [code, setCode] = useState("");
  const [loading, setLoading] = useState(false);

  const handleVerify = async (e) => {
    e.preventDefault();
    if (code.length !== 6) {
      return toast.error("El código debe tener 6 dígitos");
    }

    setLoading(true);
    try {
      // Aquí conectaremos con Python más adelante
      await axios.post(`${API}/public/verify-code`, { email, code });
      
      toast.success("¡Correo verificado con éxito!");
      // Si el código es correcto, lo mandamos a pagar
      navigate("/admin/subscription", { state: { email } });
    } catch (error) {
      toast.error("Código incorrecto o expirado. Intenta de nuevo.");
    } finally {
      setLoading(false);
    }
  };

  const handleResendCode = async () => {
    try {
      await axios.post(`${API}/public/resend-code`, { email });
      toast.success("Te hemos enviado un nuevo código");
    } catch (error) {
      toast.error("Error al reenviar el código");
    }
  };

  return (
    <div className="min-h-screen bg-[#09090b] flex items-center justify-center px-6 py-12">
      <div className="w-full max-w-md bg-zinc-900 border border-zinc-800 p-8 shadow-xl rounded-xl text-center">
        <div className="bg-amber-500/10 w-20 h-20 rounded-full flex items-center justify-center mx-auto mb-6 border border-amber-500/20">
          <Mail className="w-10 h-10 text-amber-500" />
        </div>
        
        <h2 className="font-heading text-2xl font-bold uppercase text-white mb-2">
          Revisa tu Correo
        </h2>
        <p className="text-zinc-400 mb-6 text-sm">
          Hemos enviado un código de 6 dígitos a <br/>
          <strong className="text-amber-500">{email}</strong>
        </p>

        <form onSubmit={handleVerify} className="space-y-6">
          <div>
            <input
              type="text"
              maxLength="6"
              placeholder="000000"
              value={code}
              onChange={(e) => setCode(e.target.value.replace(/[^0-9]/g, ''))}
              className="w-full bg-zinc-800 border border-zinc-700 text-white h-16 text-center text-3xl tracking-[1em] font-bold rounded-lg focus:border-amber-500 focus:ring-1 focus:ring-amber-500 outline-none transition-all"
            />
          </div>

          <button 
            type="submit" 
            disabled={loading || code.length !== 6}
            className="w-full bg-amber-500 text-black hover:bg-amber-400 disabled:opacity-50 disabled:cursor-not-allowed font-heading uppercase tracking-wider font-bold h-12 flex items-center justify-center rounded-lg transition-colors"
          >
            {loading ? "Verificando..." : "Verificar y Continuar"}
            {!loading && <ArrowRight className="w-5 h-5 ml-2" />}
          </button>
        </form>

        <div className="mt-8 pt-6 border-t border-zinc-800">
          <p className="text-zinc-500 text-sm mb-3">¿No recibiste el correo?</p>
          <button 
            onClick={handleResendCode}
            className="text-amber-500 hover:text-amber-400 text-sm font-bold flex items-center justify-center w-full"
          >
            <RefreshCw className="w-4 h-4 mr-2" /> Reenviar código
          </button>
        </div>
      </div>
    </div>
  );
};

export default VerifyEmailPage;